/**
 * @module core
 */

/* jshint -W079 */
var document = global.document;
var console = global.console;
/* jshint +W079 */

/**
 * @const {String}
 * @private
 */

//var BASE_MODULE_URL = 'http://qsdqsd';

function appendScript(script) {

	var parent = document.body || document.getElementsByTagName('head')[0];

	if (parent) {

		parent.appendChild(script);

	} else {

		setTimeout(function() {
			appendScript(script);
		}, 1);

	}

}

function onScriptLoad(script, callback) {

	var loaded = false;
	return function() {

		if ((script.readyState && script.readyState !== 'complete' && script.readyState !== 'loaded') || loaded) {
			return;
		}

		loaded = true;
		script.onload = script.onreadystatechange = null;
		callback(null);

	};

}

module.exports = {

	global: global,

	// script error/load event, IE9+
	load: function(scriptUrl, callback) {

		var script = document.createElement('script');
		script.async = true;
		script.type = 'text/javascript';
		script.src = scriptUrl;
		script.onload = script.onreadystatechange = onScriptLoad(script, callback);
		appendScript(script);

	},

	/**
	   * Retourne le nombre de millisecondes écoulées depuis le 1er Janvier 1970
	   * à minuit UTC
	   *
	   * @returns Number
	   *
	   * @see https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Date/now
	   */
	now: function() {

		return Date.now ? Date.now() : +new Date;

	},

	log: function() {

		if (console && console.log) {
			console.log.apply(console, arguments);
		}

	},

	warn: function() {

		if (console && console.warn) {
			console.warn.apply(console, arguments);
		}

	},

	error: function() {

		if (console && console.error) {
			console.error.apply(console, arguments);
		}

	},

	/**
	   * Génère une chaine de caractères
	   *
	   * @param {Number} length Longueur souhaitée pour la chaine de caractères retournée
	   *
	   * @returns String
	   */
	makeRandomString: function(length) {

		var randomString = '';
		for (var i = 0; i < length; i++) {

			randomString += Math.floor(Math.random() * 16).toString('16');

		}

		return randomString;

	},

	/**
	   * Array.prototype.slice
	   *
	   * @method
	   * @param {Number} begin
	   * @param {Number} end
	   *
	   * @returns Array
	   *
	   * @see https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/slice
	   */
	slice: Array.prototype.slice,

	/**
	   * Polyfill pour Object.create, ne supporte pas "propertiesObject"
	   *
	   * @method
	   * @param {Object} object
	   * @param {Object} propertiesObject
	   *
	   * @returns Function
	   *
	   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create
	   */
	createObject: typeof Object.create === 'function' ? (function(prototype, propertiesObject) {

		return Object.create(prototype, propertiesObject);

	}) : (function() {

		var Temp = function() {};

		return function(prototype) {

			if (arguments.length > 1) {
				throw new Error('Second argument not supported');
			}

			if (typeof prototype !== 'object') {
				throw new TypeError('Argument must be an object');
			}

			Temp.prototype = prototype;
			var result = new Temp();
			Temp.prototype = null;
			return result;

		};

	})()

};
